import React from 'react';
import InfoPage from './InfoPage';

const SupportPage = () => {
  return <InfoPage type="support" />;
};

export default SupportPage;
